import React, { useState, useEffect, useRef } from "react";
import Menu from "./MenuList";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleSidebar = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="sidebar-container">
      <div className="sidebar-toggle lg:mt-0 " onClick={toggleSidebar}>
        {isOpen ? (
          <i className="fa-solid fa-bars"></i>
        ) : (
          <i className="fa-solid fa-bars"></i>
        )}
      </div>

      <div
        ref={sidebarRef}
        className={`sidebar bg-white/100 shadow backdrop-blur-md lg:bg-transparent border-r ${
          isOpen ? "open" : "closed"
        }`}
      >
        {/*  */}
        <div className="sidebar-logo mt-10 flex justify-center">
          <img className="w-32" src="../../assets/logo.jpg" alt="" />
        </div>
        <Menu onMenuItemClick={toggleSidebar} />
      </div>
    </div>
  );
};

export default Sidebar;
